import { SWRFetcher } from '@commenda/utils';
import useSWR from 'swr';
import { TMarketplaceService } from './types';

export function useMarketplaceService(
  id: string,
  params?: {
    includeChatRoom?: boolean;
    includeStatusUpdates?: boolean;
    companyId: number;
  }
) {
  const queryParams = new URLSearchParams();
  if (params?.includeChatRoom) queryParams.set('includeChatRoom', 'true');

  if (params?.includeStatusUpdates)
    queryParams.set('includeStatusUpdates', 'true');

  const { data, error, mutate } = useSWR<TMarketplaceService>(
    id ? `marketplace/service-requests/${id}?${queryParams.toString()}` : null,
    SWRFetcher({
      method: 'GET',
    })
  );
  return { data, error, mutate };
}
